import PropTypes from 'prop-types';
import React, { Component } from 'react';
import autoBind from 'react-autobind';
import classNames from 'classnames';
import LoadingSpinner from 'ui/common/rebranding/components/LoadingSpinner';
import './styles.scss';

// import axios, { post } from 'axios';

class FileUploadButton extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      file: null,
      label: this.props.children,
    };
  }

  onChange(e) {
    let fileName = '';

    this.props.onHandleInputChange(e);
    if (e.target.files && e.target.files.length > 1) {
      fileName = (e.target.getAttribute('data-multiple-caption') || '').replace(
        '{count}',
        e.target.files.length.toString()
      );
    } else {
      fileName = e.target.value.split('\\').pop();
    }

    if (fileName) {
      this.setState({ file: fileName });
    }
  }

  onFormSubmit(e) {
    e.preventDefault(); // Stop form submit
  }

  fileUpload(file) {
    // TODO: Send form to respective store / API point
    // Example with Axios:
    // const url = 'http://example.com/file-upload';
    // const formData = new FormData();
    // formData.append('file', file);
    // const config = {
    //   headers: {
    //     'content-type': 'multipart/form-data'
    //   }
    // };
    // return  post(url, formData,config)
  }

  render() {
    const {
      children,
      className,
      disabled,
      isReady,
      kind,
      id,
      tabIndex,
      onHandleInputChange,
      isUploading,
      ...other
    } = this.props;

    const fileUploadButtonClasses = classNames(className, 'btn btn-file-upload', {
      'is-ready': isReady,
      'btn-primary': kind === 'primary',
      'btn-secondary': kind === 'secondary',
    });

    // const commonProps = {
    //   tabIndex,
    //   className: fileUploadButtonClasses,
    // };

    return (
      <label htmlFor={id} className={fileUploadButtonClasses}>
        <input
          id={id}
          className="input-hidden"
          name="file"
          type="file"
          {...other}
          data-multiple-caption="{count} files selected"
          onChange={this.onChange}
        />
        {/*
          <button type="submit" {...other} {...commonProps} disabled={disabled}>
            Submit
          </button>
        */}
        <span className="file-upload-label-text">
          {this.state.file ? `${this.state.file.substring(0, 8)}...` : this.state.label}
          {isUploading && (
            <span className="d-inline-item float-right ml-2">
              <LoadingSpinner className="loading-icon" />
            </span>
          )}
        </span>
      </label>
    );
  }
}

FileUploadButton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  kind: PropTypes.oneOf(['primary', 'secondary', 'disabled']).isRequired,
  id: PropTypes.string.isRequired,
  tabIndex: PropTypes.number,
  role: PropTypes.string,
  isReady: PropTypes.bool,
  isUploading: PropTypes.bool,
  onHandleInputChange: PropTypes.func.isRequired,
};

FileUploadButton.defaultProps = {
  tabIndex: 0,
  disabled: false,
  isReady: false,
  kind: 'primary',
};

export default FileUploadButton;



// WEBPACK FOOTER //
// ./src/ui/common/rebranding/components/Button/FileUploadButton.js